/**
 * **時間の仕組みのフレーム → `duelEditor` の `scene`**（Issue #523）。**`duelEditor/` の外**。
 *
 * `duelEditor/` の舞台はドメインの写し方を知らない（`boundary.test.js`）。逆に時間の仕組み（`duelEditor/timeline/`）は
 * ドメイン（カード・LP）を知らない。**両方を知ってよいのがこの層**なので、写し替えはここに置く。
 * おかげで **`duelEditor/` は時間が入っても 1 行も変わらない**（受け取るのは「そのフレームの値」）。
 *
 * 盤面の形の写し替えは `duelBoard.js`（`duelEditor/core/board` の「ゾーンのキー → 置いてあるもの」へ）。
 */
import { handCounts, toDuelBoard } from './duelBoard';

/**
 * エディタのフレーム ＋ ページが調達した素材 → `duelEditor` の `scene`。
 *
 * **LP の動き（カウントダウンと残像）はここで手に入る** —— 状態チャンネルの HUD が
 * `lpDisplay`（イージング済み）と `lpGhost`（遅れて追いつく）を出すので、そのまま渡すだけ。
 *
 * @param frame `editor.frameAt(ms)` の結果
 * @param config 描画側の設定（コアは中身を見ずに素通しする）。
 *   `{ field, video, cards, players, board }`。`board` はイベントが無いときの逃げ道（replay の 1 枚）
 */
export function toDuelScene(frame, config = {}) {
  const states = frame?.states ?? {};
  // **イベントがまだ無い（読み込み中・replay に操作が 1 つも無い）ときは replay の 1 枚に落ちる**
  const board = toDuelBoard(states.board, config.board);
  const hud = states.hud ?? null;
  return {
    field: config.field,
    /** **演出が置いたもの**（Issue #534）。生存は `fx_objects` チャンネルが持つ */
    fxObjects: states.fx_objects ?? [],
    /** **舞台の設定**（Issue #535。グローバル 1 枠。ページがカメラと Field に当てる） */
    fxScene: states.fx_scene ?? null,
    frameMs: frame?.ms ?? 0,
    /** 書体が読めたか（読めたら紙とテクスチャを描き直す。Issue #549） */
    fontReady: config.fontReady ?? true,
    // **盤の紙が描く同梱の画像が読めたか**（Issue #565。テーマの `images`。変わったら紙を描き直す）
    imagesReady: config.imagesReady ?? true,
    video: config.video ?? { el: null, size: null },
    cards: config.cards ?? { image: () => null, name: () => null, sleeve: () => null },
    players: config.players ?? [],
    board,
    hud: {
      players: config.players ?? [],
      life: hud?.lpDisplay ?? [8000, 8000],
      lifeGhost: hud?.lpGhost ?? hud?.lpDisplay ?? [8000, 8000],
      lifeTarget: hud?.lp ?? hud?.lpDisplay ?? [8000, 8000],
      lifeFrom: hud?.lpFrom ?? hud?.lp ?? hud?.lpDisplay ?? [8000, 8000],
      hands: handCounts(board),
      turn: hud?.turn ?? 0,
      phaseLabel: hud?.phaseLabel ?? null,
      turnPlayer: hud?.turnPlayer ?? 0,
    },
  };
}
